// extracted by mini-css-extract-plugin
module.exports = {"explanation":"Branding_explanation__2psm3","colorPickersContainer":"Branding_colorPickersContainer__O8KoE","colorPicker":"Branding_colorPicker__2ObsJ"};